import SFSwitch from '@/component/common/sf-switch';
import SFMenu from '@/component/my/sf-menu';
import {
  bioLocalStorage,
  setBioLocalStorage,
  deleteStorage,
  getStorage,
  localGetStorage,
  localSetStorage,
  setStorage,
} from '@/lib/storage';
import { usePinInfo } from '@/store/zustand/store';
import { Typography } from '@mui/material';
import { useState, ChangeEvent, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { bio_auth, bio_reg_check } from '@/component/linkMobile/bio';
import { toast } from 'react-toastify';
import { encryptData } from '@/lib/Cryptos';

export function BioUse({ isEmail }: { isEmail: boolean }) {
  const [isReFingerPrint, setIsReFingerPrint] = useState(false);
  const [fingerPrint, setFingerPrint] = useState(false);
  const pinInfo = usePinInfo();
  const navigate = useNavigate();
  const bioType = useRef(''); // check || result || done

  // 초기 로드 시 생체인증 등록 상태 확인
  useEffect(() => {
    const bio = bioLocalStorage();
    if (bio) {
      setFingerPrint(true);
      setIsReFingerPrint(true);
    }
  }, []);

  // PIN 확인 후 돌아왔을 때 생체인증 처리
  useEffect(() => {
    if (pinInfo.active) {
      checkBio();
    }
  }, [pinInfo, isEmail]);

  const checkBio = () => {
    const bio = bioLocalStorage();
    if (bio) {
      setFingerPrint(true);
      setIsReFingerPrint(true);
    }

    const reBio = getStorage('bio');
    let type = null;
    if (reBio) {
      const re = JSON.parse(reBio);
      type = re.type;
    }

    if (requireBio() && bio && type) {
      // 재등록 요청
      bioAuth(true);
      deleteStorage('bio');
      bioType.current = 'result';
    } else if (requireBio() && bio) {
      // 이미 등록됨 - 앱에서 등록 상태 확인
      bio_reg_check();
      bioType.current = 'check';
    } else if (requireBio() && !bio) {
      // 신규 등록
      bioAuth(false);
      bioType.current = 'result';
    }
  };

  const requireBio = () => {
    return pinInfo.active && pinInfo.path === '/securityCenter' && pinInfo.pinNum;
  };

  // 앱에서 생체인증 결과 콜백
  window.appInterFace = (val: any, data?: any) => {
    bioInterFace(val);
  };

  const bioInterFace = (val: any) => {
    if (bioType.current === 'check') {
      // 1: 인증정보 등록됨, 0: 미등록
      if (val === '1') {
        // 이미 등록되어 있음
        bioReg();
      } else if (val === '0') {
        // 앱에 등록 안됨 → 신규 등록 진행
        bioAuth(false);
        bioType.current = 'result';
      }
    } else if (bioType.current === 'result') {
      // 1:인증성공, 2:인증등록성공(안드로이드용), 0:인증실패
      if (val === '1' || val === '2') {
        toast.success('생체인증 등록 성공');
        // localStorage에 등록 상태 저장
        setBioLocalStorage('bio_check', 1);
        setFingerPrint(true);
        setIsReFingerPrint(true);
      } else {
        toast.error('인증에 실패하였습니다.');
      }
      bioType.current = 'done';
    }
  };

  const bioReg = () => {
    bioType.current = 'done';
    setFingerPrint(true);
    setIsReFingerPrint(true);
  };
  const bioAuth = (renewal: boolean = false) => {
    const keyData = checkSns();
    if (keyData === '') return;
    const encrypted = setEncrypt(keyData);
    bio_auth(renewal, encrypted);
  };

  const checkSns = (): string => {
    const snsAddress = localGetStorage('snsAddress');
    const idToken = snsAddress?.idToken;
    if (!idToken) {
      return '';
    }
    return idToken;
  };

  const setEncrypt = (keyData: string): string => {
    const key = process.env.REACT_APP_CRYPTO_SOLT + keyData;
    return encryptData(pinInfo.pinNum, key);
  };

  const handleFingerPrintSwitch = (event: ChangeEvent<HTMLInputElement>) => {
    setFingerPrint(event.target.checked);
    if (event.target.checked) {
      // 활성화: PIN 확인 후 생체인증 등록
      navigate('/pinComponent', {
        state: {
          pinType: 'check',
          title: 'PIN 번호 확인',
          returnUrl: '/securityCenter',
          options: {
            check: 'security',
          },
        },
      });
    } else {
      // 비활성화: 생체인증 해제
      setBioLocalStorage('bio_check', 0);
      const temp = localGetStorage('login');
      const payload = {
        key: 'login',
        value: {
          ...temp,
          auth: '',
        },
      };
      localSetStorage(payload);
      setIsReFingerPrint(false);
    }
  };

  return (
    <>
      <SFMenu.BetweenItem
        leftContent={<Typography variant="subtitle2">지문 사용</Typography>}
        rightContent={<SFSwitch onChange={handleFingerPrintSwitch} checked={fingerPrint} />}
      />
      {isReFingerPrint && (
        <SFMenu.ArrowRightItem
          text="지문 재등록"
          onClick={() => {
            // 재등록 플래그 설정
            const payload = {
              key: 'bio',
              value: { type: 'reset' },
            };
            setStorage(payload);
            navigate('/pinComponent', {
              state: {
                pinType: 'check',
                title: 'PIN 번호 확인',
                returnUrl: '/securityCenter',
                options: {
                  check: 'security',
                },
              },
            });
          }}
        />
      )}
    </>
  );
}
